import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import { ReadReceiptActionType } from '@/modules/readreceipt/enums/ReadReceiptActionType';

export class ReadReceipt extends BaseEntityModel {
  id?: number;
  modelType?: ModelType;
  modelId?: number;
  userId?: number;
  readAt?: string;
  actionType?: string | null;

  constructor(model: Partial<ReadReceipt> = {}) {
    super(model);
    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.userId = model.userId;
    this.readAt = model.readAt;
    this.actionType = model.actionType;
  }

  isActionTypeCreated(): boolean {
    return this.actionType === ReadReceiptActionType.CREATED.key;
  }

  isActionTypeUpdated(): boolean {
    return this.actionType === ReadReceiptActionType.UPDATED.key;
  }

  static findUnreadForUser(
    receipts: ReadReceipt[] | null | undefined,
    userId: number
  ): ReadReceipt | undefined {
    return receipts?.find(
      (receipt: ReadReceipt) => receipt.userId === userId && receipt.readAt === null
    );
  }
}
